import { Box, MenuItem, Select } from '@mui/material';
import { SecurityInventoryCategory } from '@x-guard/xgac-types/xgac';
import { useState } from 'react';
import { useTranslate } from 'react-admin';
import { IconField } from '../../../components/fields/IconField';
import { InventoryCategoryIconName } from '../../../components/icons/inventoryCategoryIcons';

export const CreateItemSection = (props: { categories: SecurityInventoryCategory[] }) => {

  const translate = useTranslate();

  const [showCategories, setShowCategories] = useState(false);

  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', gap: 1, width: '100%',
    }}>
      <button
        type="button"
        className="add-device-button"
        onClick={() => setShowCategories((open) => !open)}
        style={{
          width: '100%',
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
        }}
      >
        <span>{translate('resources.security-inventory-items.text.add_item')}</span>
      </button>
      {showCategories && (
        <Select
          size="small"
          fullWidth
          displayEmpty
          value=""
          onChange={() => setShowCategories(false)}
          renderValue={() => <span style={{ color: '#888' }}>{translate('resources.security-inventory-categories.text.select_category')}</span>}
        >
          {props.categories.map((category) => (
            <MenuItem key={category._id} value={category._id}>
              <IconField iconName={category.icon as InventoryCategoryIconName} source={category.icon} />
              <span style={{ marginLeft: '10px' }}></span>
              {category.name}
            </MenuItem>
          ))}
        </Select>
      )}

    </Box>
  );

};
